<template>
	<div :style="{ height: height + 'px' }">
		<div class="top middle-row around">
			<h3>日报中心</h3>
			<div class="input-group" style="width:20%;">
				<span class="input-group-addon">设备类型</span>
				<select name="" id="select" v-model="type" class="form-control" @change="change">
					<option v-for="(target, i) in types" :value="target" :key='i'>{{ target }}</option>
				</select>
			</div>
			<div class="middle-row center" style="width:20%;">
				<div class="input-group" style="margin: 5px">
					<input type="text" id="start" class="form-control">
					<span class="input-group-addon">请选择日报时间</span>
				</div>
			</div>
		</div>
		<div class="dailyinfo middle-column start" style="overflow-y: scroll;" :style="{ height: height - 64 + 'px' }">
			<table class="table" style="background-color: white;">
				<caption style="font-size: 20px;">每日报警统计表</caption>
				<thead>
					<tr>
						<th v-for="(th, index) in ths" :key='index'>{{ th }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(data, index) in dailyData" :key='index'>
						<td>{{ index + 1 }}</td>
						<td>{{ data._id }}</td>
						<td>{{ data.street }}</td>
						<td>{{ data.tt }}</td>
						<td>{{ data.min }}--{{ data.max }}</td>
						<td>{{ data.start }}--{{ data.end }}</td>
						<td>{{ data.count }}</td>
					</tr>
				</tbody>
			</table>
			<table class="table" style="background-color: white;">
				<caption style="font-size: 20px;">每日离线设备统计表</caption>
				<thead>
					<tr>
						<th v-for="(th, index) in ths2" :key='index'>{{ th }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(mer, index) in offline" :key='index'>
						<td>{{ index + 1 }}</td>
						<td>{{ mer.merchantName }}</td>
						<td>{{ mer.lastTime }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import { util } from '../../static/util.js'
export default ({
	data() {
		return {
			height: 0,
			start: '',
			end: '',
			dailyData: '',
			types: ['餐饮油烟排放', 'VOCS排放', '工地扬尘', '工业企业废气'],
			yesterday: '',
			ths: ['序号', '商户名称', '所属街道', '超标类型', '监测值', '超标时间段', '超标次数'],
			ths2: ['序号', '商户名称', '最后一次上传数据时间'],
			type: '',
			offline: []
		}
	},
	methods: {
		getDailyReport() {
			this.$http.get(this.GLOBAL.base + 'dailyReport', { params: { start: this.start, end: this.end, type: this.type } }).then(function (res) {
				this.dailyData = res.body;
				for (let dd of this.dailyData) {
					dd.tt = Object.keys(dd.max[0])[0];
					dd.max = Object.values(dd.max[0])[0].toFixed(2);
					dd.min = Object.values(dd.min[0])[0].toFixed(2);
					dd.start = util.timeToStringWithMonth(dd.start);
					dd.end = util.timeToStringWithMonth(dd.end);
				}
				this.$http.get(this.GLOBAL.base + 'dailyOffline', { params: { start: this.start } }).then(function (res) {
					this.offline = res.body;
					for (let mer of this.offline) {
						if (mer.lastTime == 0) {
							mer.lastTime = '未接收到数据';
						} else {
							mer.lastTime = util.timeToStringWithMonth(mer.lastTime);
						}
					}
				})
			})

		},
		change() {
			this.getDailyReport();
		}
	},
	mounted() {
		this.height = this.GLOBAL.rightheight;
		var year = new Date().getFullYear();
		var month = new Date().getMonth() + 1;
		var day = new Date().getDate() - 1;
		this.yesterday = year + '-' + month + '-' + day;
		var that = this;
		this.start = new Date(this.yesterday).valueOf();
		this.end = this.start + 24 * 60 * 60 * 1000;
		this.type = this.types[0];
		laydate.render({
			elem: '#start', //指定元素.
			type: 'date',
			range: false,
			format: 'yyyy-MM-dd',
			value: that.yesterday,
			max: -1,
			done: function (value, startData, endData) {
				const startDate = new Date(startData.year, startData.month - 1, startData.date, 0, 0, 0);
				that.start = startDate.getTime();
				that.end = that.start + 24 * 60 * 60 * 1000;
				that.getDailyReport();
			}
		});

		this.getDailyReport();
	}
})

</script>

<style>
.top {
	padding: 10px 5px;
}

.dailyinfo {
	padding: 0px 5px 0px 5px;
	border-top: 2px solid white;
}
</style>
